import {NgModule, Optional, SkipSelf} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';

import {ErrorInterceptor, HttpTokenInterceptor} from './interceptors';

import {AuthGuard} from './guards';
import {InSidebarOverlayContainer} from './utils/in-sidebar-overlay-container';
import {OverlayContainer} from '@angular/cdk/overlay';


@NgModule({
  declarations: [
  ],
  exports: [
    HttpClientModule,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FlexLayoutModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // { provide: OverlayContainer, useClass: InSidebarOverlayContainer }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
